var _defs, _rect, _text, _text2, _text3, _rect2, _text4, _text5, _text6, _path, _path2, _path3, _rect3, _text7, _text8, _rect4, _text9, _text10, _rect5, _text11, _text12, _line, _text13, _text14, _text15, _line2, _line3, _circle, _text16, _text17, _circle2, _text18, _text19, _circle3, _text20, _text21, _rect6, _text22, _text23, _text24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase4Fig4RetroPromotionPath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 660",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arr",
    markerWidth: 8,
    markerHeight: 8,
    refX: 7,
    refY: 4,
    orient: "auto",
    markerUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L8,4 L0,8 Z",
    fill: "#6B7F74"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 660,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The retro promotion path")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "One surprise becomes up to three artifacts, and a surprise that repeats crosses a promotion threshold into a tracked fix.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 116,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "ONE SURPRISE, UP TO THREE ARTIFACTS")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 180,
    width: 210,
    height: 120,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 222,
    fontSize: 17,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Surprise")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 248,
    fontSize: 12,
    fill: "#4A5F56"
  }, "an outcome the plan")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 266,
    fontSize: 12,
    fill: "#4A5F56"
  }, "did not predict")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258,240 C370,240 420,178 548,178",
    fill: "none",
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arr)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258,240 C370,240 420,274 548,274",
    fill: "none",
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arr)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M258,240 C370,240 420,370 548,370",
    fill: "none",
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3",
    markerEnd: "url(#arr)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 140,
    width: 420,
    height: 76,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 584,
    y: 170,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Memory entry")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 584,
    y: 194,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "incident, why, how to apply")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 236,
    width: 420,
    height: 76,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 584,
    y: 266,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Artifact edit")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 584,
    y: 290,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "an edit to the artifact that allowed the failure")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 332,
    width: 420,
    height: 76,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 584,
    y: 362,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Filed issue")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 584,
    y: 386,
    fontSize: 12.5,
    fill: "#4A5F56"
  }, "opened when the fix is larger")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 432,
    x2: 1152,
    y2: 432,
    stroke: "#D4DDD6",
    strokeWidth: 1
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 466,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "THE SAME SURPRISE, RECURRING")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 494,
    fontSize: 12,
    fill: "#4A5F56"
  }, "the same surprise logged on three consecutive cadence ticks")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 474,
    textAnchor: "middle",
    fontSize: 11.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "meta-retro threshold")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 650,
    y1: 484,
    x2: 650,
    y2: 598,
    stroke: "#1A2F2A",
    strokeWidth: 1.5,
    strokeDasharray: "6 4"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 545,
    x2: 762,
    y2: 545,
    stroke: "#D4DDD6",
    strokeWidth: 2,
    markerEnd: "url(#arr)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 545,
    r: 15,
    fill: "#FFFFFF",
    stroke: "#DC2626",
    strokeWidth: 1.5
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 551,
    textAnchor: "middle",
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 16,
    fontWeight: 700,
    fill: "#DC2626"
  }, "!")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 586,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#6B7F74"
  }, "tick 1")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 545,
    r: 15,
    fill: "#FFFFFF",
    stroke: "#DC2626",
    strokeWidth: 1.5
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 551,
    textAnchor: "middle",
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 16,
    fontWeight: 700,
    fill: "#DC2626"
  }, "!")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 586,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#6B7F74"
  }, "tick 2")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 545,
    r: 15,
    fill: "#FFFFFF",
    stroke: "#DC2626",
    strokeWidth: 1.5
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 551,
    textAnchor: "middle",
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 16,
    fontWeight: 700,
    fill: "#DC2626"
  }, "!")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 586,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#6B7F74"
  }, "tick 3")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 503,
    width: 290,
    height: 84,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 804,
    y: 533,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "CROSSED THE THRESHOLD")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 804,
    y: 566,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "tracked fix ", /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 19,
    fontWeight: 700,
    fill: "#16A34A"
  }, "#306"))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 612,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "A surprise seen once is encoded on the spot, and a surprise seen three times becomes tracked fix #306.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase4Fig4RetroPromotionPath);
export default __webpack_public_path__ + "static/media/case4-fig4-retro-promotion-path.a5581a81d237d936818c4d17cbbd791b.svg";
export { ForwardRef as ReactComponent };